<script lang="ts">
  import type { MemberStage } from '../admin';
  import { stageMeta } from '@ui/stages';

  let { stage, momentum = null }: { stage: MemberStage; momentum?: number | null } = $props();

  // Colour/label come from the shared stage meta; the badge tints its own
  // background (faint fill + solid text) so it reads in light and dark.
  // Null = the terminal storage marker: a member who has left has no momentum to
  // report, and the contributor-role badge next to this one already says they're
  // gone. Rendering nothing is the point — see stages.ts.
  const m = $derived(stageMeta(stage));
</script>

{#if m}
  <span
    class="inline-flex items-center gap-1 rounded px-1.5 py-0.5 font-mono text-[0.65rem]"
    style="background: color-mix(in oklab, {m.color} 16%, transparent); color: {m.color}"
    title={momentum != null ? `${m.label} · momentum ${momentum > 0 ? '+' : ''}${(momentum * 100).toFixed(0)}` : m.label}
  >
    {m.label}
  </span>
{/if}
